// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const swellow: PokeData = {
  "id": 277,
  "name": "swellow",
  "height": 7,
  "weight": 198,
  "base_experience": 159,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "growl",
    "peck",
    "agility",
    "quick-attack",
    "double-team",
    "focus-energy",
    "reversal",
    "endeavor",
    "aerial-ace",
    "pluck",
    "air-slash",
    "brave-bird",
    "quick-guard"
  ],
  "moves": [
    "growl",
    "peck",
    "agility",
    "quick-attack",
    "aerial-ace",
    "air-slash",
    "brave-bird",
    "refresh",
    "acrobatics",
    "body-slam",
    "hurricane",
    "protect",
    "gust"
  ],
  "evolution_chain": {
    "id": 138,
    "item": null,
    "species": [
      {
        "name": "taillow",
        "order": 301,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swellow",
        "order": 302,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 276,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 86,
    "speed": 187,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
